module.exports = __webpack_public_path__ + "static/usluge_02-392ed80bd6cab529f07d3874a40f2d51.jpg";